// Open cart drawer after successful add to cart
(function() {
  'use strict';
  
  // COMMENTED OUT: View cart button functionality - client no longer needs this
  /*
  // Helper function to find sibling elements
  function findSiblings(element, selector) {
    var parent = element.parentElement;
    if (!parent) return null;
    var siblings = Array.from(parent.children);
    return siblings.find(function(sibling) {
      return sibling !== element && sibling.matches && sibling.matches(selector);
    });
  }
  
  // Helper function to check if element is hidden
  function isHidden(element) {
    if (!element) return true;
    var style = window.getComputedStyle(element);
    return style.display === 'none' || style.visibility === 'hidden' || element.offsetHeight === 0;
  }
  
  // Helper function to fade in element
  function fadeIn(element, duration) {
    if (!element) return;
    element.style.display = 'block';
    element.style.opacity = '0';
    element.style.transition = 'opacity ' + duration + 'ms';
    
    // Force reflow
    element.offsetHeight;
    
    requestAnimationFrame(function() {
      element.style.opacity = '1';
    });
  }
  
  // Helper function to get cart count
  function getCartCount() {
    // Try to get from cart count element in sidebar
    var cartCountElement = document.querySelector('.sidebar__cart-handle .count');
    if (cartCountElement) {
      var count = parseInt(cartCountElement.textContent.trim());
      return isNaN(count) ? 0 : count;
    }
    
    // Try to get from cart API
    return 0; // Will be updated via AJAX if needed
  }
  
  // Helper function to check cart via AJAX
  function checkCartViaAjax(callback) {
    if (typeof fetch === 'undefined') {
      callback(getCartCount());
      return;
    }
    
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        callback(cart.item_count || 0);
      })
      .catch(function(error) {
        callback(getCartCount());
      });
  }
  
  // Function to show cart link button
  function showCartLinkButton(cartLinkButton) {
    if (!cartLinkButton) return;
    
    if (isHidden(cartLinkButton)) {
      fadeIn(cartLinkButton, 300);
    }
  }
  
  // Function to hide cart link button
  function hideCartLinkButton(cartLinkButton) {
    if (!cartLinkButton) return;
    
    if (!isHidden(cartLinkButton)) {
      cartLinkButton.style.display = 'none';
      cartLinkButton.style.opacity = '0';
    }
  }
  
  // Function to update cart link button visibility based on cart count
  function updateCartLinkButtonVisibility(cartCount) {
    var cartLinkButtons = document.querySelectorAll('.cart-link-button');
    
    cartLinkButtons.forEach(function(cartLinkButton) {
      if (cartCount > 0) {
        showCartLinkButton(cartLinkButton);
      } else {
        hideCartLinkButton(cartLinkButton);
      }
    });
  }
  
  // Check if cart-link-button exists and handle add to cart
  function initCartLinkButton() {
    // Find all cart-link-buttons
    var cartLinkButtons = document.querySelectorAll('.cart-link-button');
    
    if (cartLinkButtons.length === 0) {
      return;
    }
    
    // Check cart on page load
    checkCartViaAjax(function(cartCount) {
      updateCartLinkButtonVisibility(cartCount);
    });
    
    // Watch for changes to cart count element
    var cartCountElement = document.querySelector('.sidebar__cart-handle .count');
    if (cartCountElement) {
      var cartCountObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            var newCount = parseInt(cartCountElement.textContent.trim());
            updateCartLinkButtonVisibility(isNaN(newCount) ? 0 : newCount);
          }
        });
      });
      
      cartCountObserver.observe(cartCountElement, {
        childList: true,
        characterData: true,
        subtree: true
      });
      
      // Also watch for cart form getting cart--empty class
      var cartForm = document.querySelector('.cart__form');
      if (cartForm) {
        var cartFormObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              var target = mutation.target;
              var hasEmptyClass = target.classList.contains('cart--empty');
              
              if (hasEmptyClass) {
                // Cart is empty
                updateCartLinkButtonVisibility(0);
              } else {
                // Cart has items, check the count
                var currentCount = parseInt(cartCountElement.textContent.trim());
                updateCartLinkButtonVisibility(isNaN(currentCount) ? 0 : currentCount);
              }
            }
          });
        });
        
        cartFormObserver.observe(cartForm, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    } else {
      // Fallback: check cart periodically if element not found
      setInterval(function() {
        checkCartViaAjax(function(cartCount) {
          updateCartLinkButtonVisibility(cartCount);
        });
      }, 2000);
    }
    
    // Find each product__add-to-cart button and add click listener
    var buttons = document.querySelectorAll('button.product__add-to-cart[type="submit"]');
    
    buttons.forEach(function(button) {
      // On click, show the cart link button
      button.addEventListener('click', function(e) {
        // Show cart link button immediately on click
        cartLinkButtons.forEach(function(cartLinkButton) {
          showCartLinkButton(cartLinkButton);
        });
      });
    });
  }
  */
  
  // Function to open cart drawer
  function openCartDrawer() {
    var cartDrawer = document.querySelector('.sidebar__cart');
    var cartOverlay = document.querySelector('.cart-overlay-background');
    var body = document.body;
    
    if (!cartDrawer) {
      console.log('[Cart Drawer] Cart drawer element not found');
      return;
    }
    
    // Only open if not already opened
    if (!cartDrawer.classList.contains('opened')) {
      console.log('[Cart Drawer] Opening cart drawer');
      
      cartDrawer.classList.add('opened');
      
      if (cartOverlay) {
        cartOverlay.classList.add('show');
      }
      
      if (body) {
        body.classList.add('overflow-hidden');
      }
      
      // Calculate translation if needed (similar to theme.dev.js)
      var sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        var translation = sidebar.getBoundingClientRect().y * -1;
        cartDrawer.style.transform = 'translateY(' + translation + 'px)';
      }
      
      // Update cart form via AJAX if the function exists
      if (typeof window.cartFormAjax === 'function') {
        window.cartFormAjax();
      }
    } else {
      console.log('[Cart Drawer] Cart drawer already opened');
    }
  }
  
  // Function to update cart count in the UI
  function updateCartCount(newCount) {
    // Try to update the cart count in sidebar (if element exists)
    var cartCountElement = document.querySelector('.sidebar__cart-handle .count');
    if (cartCountElement) {
      cartCountElement.textContent = newCount;
    }
    
    // Also update the open-cart link text if it exists
    var openCartLink = document.querySelector('.open-cart');
    if (openCartLink) {
      openCartLink.textContent = 'CART (' + newCount + ')';
    }
  }
  
  // Function to fetch and update cart count
  function fetchAndUpdateCartCount(callback) {
    if (typeof fetch === 'undefined') {
      if (callback) callback(0);
      return;
    }
    
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var itemCount = cart.item_count || 0;
        updateCartCount(itemCount);
        if (callback) callback(itemCount);
      })
      .catch(function(error) {
        console.log('[Cart Drawer] Error fetching cart:', error);
        if (callback) callback(0);
      });
  }
  
  // Initialize add to cart functionality to open cart drawer
  function initAddToCartOpenDrawer() {
    var processedButtons = new WeakSet();
    var cartDrawerOpened = false;
    
    // Function to handle successful add to cart
    function handleAddToCartSuccess() {
      if (cartDrawerOpened) {
        console.log('[Cart Drawer] Already processing, skipping');
        return;
      }
      
      cartDrawerOpened = true;
      console.log('[Cart Drawer] Add to cart successful, updating cart count and opening drawer');
      
      // Fetch updated cart count and update UI
      fetchAndUpdateCartCount(function(itemCount) {
        console.log('[Cart Drawer] Cart count updated to:', itemCount);
        
        // Wait a bit more for cart form to update, then open drawer
        setTimeout(function() {
          openCartDrawer();
          // Reset flag after opening
          setTimeout(function() {
            cartDrawerOpened = false;
          }, 2000);
        }, 800);
      });
    }
    
    // Set up button observer for 'done' class
    function setupButtonObserver(button) {
      if (processedButtons.has(button)) {
        return; // Already set up
      }
      
      processedButtons.add(button);
      console.log('[Cart Drawer] Setting up observer for button');
      
      // Watch for 'done' class on button
      var buttonObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var target = mutation.target;
            console.log('[Cart Drawer] Button class changed:', target.className);
            
            // Check if button just got the 'done' class (successful add to cart)
            // and is no longer in 'working' state
            if (target.classList.contains('done') && !target.classList.contains('working')) {
              console.log('[Cart Drawer] Button has done class, triggering success handler');
              handleAddToCartSuccess();
            }
          }
        });
      });
      
      buttonObserver.observe(button, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Set up observers for existing buttons
    var addToCartButtons = document.querySelectorAll('button.product__add-to-cart[type="submit"]');
    console.log('[Cart Drawer] Found', addToCartButtons.length, 'add to cart buttons');
    addToCartButtons.forEach(setupButtonObserver);
    
    // Also watch for button clicks to log
    addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        console.log('[Cart Drawer] Add to cart button clicked');
      });
    });
    
    // Fallback: Watch for cart form updates (when items are added)
    var cartForm = document.querySelector('.cart__form');
    if (cartForm) {
      console.log('[Cart Drawer] Setting up cart form observer');
      var cartFormObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // Watch for cart items being added
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            var hasCartItems = document.querySelectorAll('.cart-item').length > 0;
            if (hasCartItems && !cartDrawerOpened) {
              console.log('[Cart Drawer] Cart items detected, triggering success handler');
              handleAddToCartSuccess();
            }
          }
          
          // Watch for cart--empty class being removed
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var target = mutation.target;
            if (!target.classList.contains('cart--empty') && target.classList.contains('cart__form')) {
              var cartItems = document.querySelectorAll('.cart-item');
              if (cartItems.length > 0 && !cartDrawerOpened) {
                console.log('[Cart Drawer] Cart form updated (not empty), triggering success handler');
                handleAddToCartSuccess();
              }
            }
          }
        });
      });
      
      cartFormObserver.observe(cartForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Watch for dynamically added buttons
    var buttonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            var newButtons = node.querySelectorAll ? node.querySelectorAll('button.product__add-to-cart[type="submit"]') : [];
            if (node.matches && node.matches('button.product__add-to-cart[type="submit"]')) {
              newButtons = [node];
            }
            
            newButtons.forEach(function(button) {
              setupButtonObserver(button);
              button.addEventListener('click', function(e) {
                console.log('[Cart Drawer] Add to cart button clicked (dynamic)');
              });
            });
          }
        });
      });
    });
    
    // Observe the document body for new buttons
    buttonObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Helper function to get product JSON data
  function getProductJson(form) {
    var productSection = form.closest('.page-section.product, .mount-product-page');
    if (!productSection) return null;
    
    var productJsonElement = productSection.querySelector('.product-json');
    if (!productJsonElement) return null;
    
    try {
      return JSON.parse(productJsonElement.textContent);
    } catch (e) {
      return null;
    }
  }
  
  // Helper function to clean option value (remove extra text like " - (Sold out)")
  function cleanOptionValue(value) {
    if (!value) return '';
    
    // Decode URL encoding
    try {
      value = decodeURIComponent(value);
    } catch (e) {
      // If decoding fails, use original value
    }
    
    // Remove patterns like " - (Sold out)" or " - (Last 1 Left)"
    return value.replace(/\s*-\s*\([^)]+\)\s*$/, '').trim();
  }
  
  // Helper function to find variant by option values
  function findVariantByOptions(productJson, optionValues) {
    if (!productJson || !productJson.variants) return null;
    
    // Clean the option values
    var cleanedValues = optionValues.map(function(val) {
      return cleanOptionValue(val);
    });
    
    for (var i = 0; i < productJson.variants.length; i++) {
      var variant = productJson.variants[i];
      var matches = true;
      
      // Check if variant options match the provided option values
      for (var j = 0; j < cleanedValues.length; j++) {
        var optionIndex = j + 1; // option1, option2, option3
        var optionKey = 'option' + optionIndex;
        var variantOptionValue = variant[optionKey] || '';
        
        // Compare cleaned values
        if (variantOptionValue.trim() !== cleanedValues[j]) {
          matches = false;
          break;
        }
      }
      
      if (matches) {
        return variant;
      }
    }
    
    return null;
  }
  
  // Helper function to get quantity text for a variant
  function getQuantityText(variant, productSelect) {
    if (!variant) return '(Sold Out)';
    
    // Find the variant option in productSelect
    var variantOption = productSelect.querySelector('option[value="' + variant.id + '"]');
    if (!variantOption) {
      // Try to get quantity from variant object directly if available
      if (variant.inventory_quantity !== undefined) {
        var qty = parseInt(variant.inventory_quantity);
        if (qty === 1) {
          return '(Last 1 left)';
        } else if (qty >= 2 && qty <= 3) {
          return '(Low Stock)';
        } else if (qty <= 0) {
          return '(Sold Out)';
        } else {
          return ''; // Don't show for qty > 3
        }
      }
      return '(Sold Out)';
    }
    
    var quantity = variantOption.getAttribute('data-quantity');
    var inventory = variantOption.getAttribute('data-inventory');
    var isAvailable = !variantOption.disabled;
    
    // If data-quantity is not set, try to get from variant object
    if (!quantity && variant.inventory_quantity !== undefined) {
      quantity = variant.inventory_quantity.toString();
    }
    
    if (!isAvailable) {
      return '(Sold Out)';
    } else if (quantity === '0' || quantity === null || quantity === undefined || parseInt(quantity) <= 0) {
      return '(Sold Out)';
    } else {
      var qty = parseInt(quantity);
      // Show inventory for quantity range 1-3
      if (qty === 1) {
        return '(Last 1 left)';
      } else if (qty >= 1) {
        return '(Low Stock)';
      } else {
        return ''; // Don't show for qty > 3
      }
    }
  }
  
  // Update variant inventory quantity display
  function updateVariantInventoryQuantity() {
    // Find all product forms
    var productForms = document.querySelectorAll('.product__form');
    
    productForms.forEach(function(form) {
      var productSelect = form.querySelector('#productSelect');
      if (!productSelect) return;
      
      // Get product JSON data
      var productJson = getProductJson(form);
      if (!productJson || !productJson.variants) return;
      
      // Get all variant selects
      var variantSelects = Array.from(form.querySelectorAll('.product__variant'));
      if (variantSelects.length === 0) return;
      
      // For each variant select
      variantSelects.forEach(function(select, selectIndex) {
        var options = Array.from(select.querySelectorAll('option'));
        
        // For each option in this select
        options.forEach(function(option) {
          var span = option.querySelector('.variant-inventory-quantity');
          if (!span) return;
          
          // Clean the option value to get the base value
          var cleanedOptionValue = cleanOptionValue(option.value);
          
          // Find the variant that matches this option value
          var variant = null;
          
          // For single option products, match directly by option1
          if (variantSelects.length === 1) {
            for (var i = 0; i < productJson.variants.length; i++) {
              var v = productJson.variants[i];
              var cleanedVariantOption1 = cleanOptionValue(v.option1 || '');
              if (v.option1 && cleanedVariantOption1 === cleanedOptionValue) {
                variant = v;
                break;
              }
            }
          } else {
            // For multiple options, build the selection array
            var currentSelections = [];
            variantSelects.forEach(function(s, idx) {
              if (idx === selectIndex) {
                currentSelections.push(option.value);
              } else {
                var selectedOption = s.options[s.selectedIndex];
                if (selectedOption && selectedOption.value) {
                  currentSelections.push(selectedOption.value);
                } else {
                  var firstOption = s.options[0];
                  if (firstOption && firstOption.value) {
                    currentSelections.push(firstOption.value);
                  } else {
                    currentSelections.push('');
                  }
                }
              }
            });
            variant = findVariantByOptions(productJson, currentSelections);
          }
          
          // Get quantity text for this variant
          var quantityText = getQuantityText(variant, productSelect);
          
          // Update the span in the option element
          if (quantityText) {
            span.textContent = ' ' + quantityText;
            span.style.display = '';
          } else {
            span.textContent = '';
            span.style.display = 'none';
          }
          
          // Also update the visible dropdown item if it exists
          var selectHolder = select.closest('.product__variant-holder');
          if (selectHolder) {
            // Try both encoded and non-encoded values
            var dataValueEncoded = encodeURIComponent(option.value);
            var dataValueDecoded = option.value;
            
            var visibleItem = selectHolder.querySelector('.regular-select-item[data-value="' + dataValueEncoded + '"]') ||
                             selectHolder.querySelector('.regular-select-item[data-value="' + dataValueDecoded + '"]');
            
            if (visibleItem) {
              // Remove any existing quantity text
              var existingQuantity = visibleItem.querySelector('.variant-inventory-quantity');
              if (existingQuantity) {
                if (quantityText) {
                  existingQuantity.textContent = ' ' + quantityText;
                  existingQuantity.style.display = '';
                } else {
                  existingQuantity.textContent = '';
                  existingQuantity.style.display = 'none';
                }
              } else if (quantityText) {
                // Add the quantity text only if it's not empty
                var quantitySpan = document.createElement('span');
                quantitySpan.className = 'variant-inventory-quantity';
                quantitySpan.textContent = ' ' + quantityText;
                visibleItem.appendChild(quantitySpan);
              }
            }
          }
        });
        
        // Update the selected text for this select after a delay to ensure styled selects and DOM are updated
        (function(selectToUpdate) {
          setTimeout(function() {
            updateSelectedText(selectToUpdate);
          }, 100);
        })(select);
      });
      
      // Update data-product-inventory-value after a delay
      (function(formToUpdate) {
        setTimeout(function() {
          updateProductInventoryValue(formToUpdate);
        }, 100);
      })(form);
    });
  }
  
  // Check if styled selects are ready
  function areStyledSelectsReady() {
    var variantSelects = document.querySelectorAll('.product__variant');
    if (variantSelects.length === 0) return false;
    
    var allReady = true;
    variantSelects.forEach(function(select) {
      var selectHolder = select.closest('.product__variant-holder');
      if (selectHolder) {
        var selectInner = selectHolder.querySelector('.regular-select-inner');
        if (!selectInner) {
          allReady = false;
        }
      }
    });
    
    return allReady;
  }
  
  // Initialize variant inventory quantity on page load with retry
  function initVariantInventoryQuantity() {
    var maxRetries = 15;
    var retryCount = 0;
    
    function tryUpdate() {
      // Check if product JSON is available
      var productForms = document.querySelectorAll('.product__form');
      var hasProductJson = false;
      
      productForms.forEach(function(form) {
        var productJson = getProductJson(form);
        if (productJson && productJson.variants) {
          hasProductJson = true;
        }
      });
      
      // Check if styled selects are ready
      var styledSelectsReady = areStyledSelectsReady();
      
      if ((hasProductJson && styledSelectsReady) || retryCount >= maxRetries) {
        updateVariantInventoryQuantity();
      } else {
        retryCount++;
        setTimeout(tryUpdate, 150);
      }
    }
    
    tryUpdate();
  }
  
  // Helper function to update the selected visible text
  function updateSelectedText(select) {
    var selectHolder = select.closest('.product__variant-holder');
    if (!selectHolder) return;
    
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;
    
    var span = selectedOption.querySelector('.variant-inventory-quantity');
    if (!span) return;
    
    var quantityText = span.textContent.trim();
    
    var selectInner = selectHolder.querySelector('.regular-select-inner');
    if (selectInner) {
      // Get the base text - clean the option value to remove status text
      var baseText = cleanOptionValue(selectedOption.value);
      
      // Update the inner text with quantity (only if quantityText is not empty)
      var newText = baseText;
      if (quantityText) {
        newText = baseText + ' ' + quantityText;
      }
      selectInner.textContent = newText;
      
      // Also update the selected .regular-select-item text if it exists
      var dataValueEncoded = encodeURIComponent(selectedOption.value);
      var selectedItem = selectHolder.querySelector('.regular-select-item.selected[data-value="' + dataValueEncoded + '"]');
      if (selectedItem) {
        // Update the selected item's text to match
        var itemText = selectedItem.textContent.trim();
        var itemQuantitySpan = selectedItem.querySelector('.variant-inventory-quantity');
        if (itemQuantitySpan) {
          var itemBaseText = itemText.replace(itemQuantitySpan.textContent, '').trim();
          if (quantityText) {
            itemQuantitySpan.textContent = ' ' + quantityText;
            itemQuantitySpan.style.display = '';
            selectedItem.innerHTML = itemBaseText + ' <span class="variant-inventory-quantity">' + quantityText + '</span>';
          } else {
            itemQuantitySpan.textContent = '';
            itemQuantitySpan.style.display = 'none';
            selectedItem.innerHTML = itemBaseText;
          }
        }
      }
    }
  }
  
  // Helper function to update data-product-inventory-value
  function updateProductInventoryValue(form) {
    // Get product JSON to find the variant
    var productJson = getProductJson(form);
    if (!productJson || !productJson.variants) {
      return;
    }
    
    // Get selected values from all variant selects (more reliable than productSelect)
    var variantSelects = Array.from(form.querySelectorAll('.product__variant'));
    var selectedOptions = [];
    
    variantSelects.forEach(function(select) {
      var selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value) {
        selectedOptions.push(selectedOption.value);
      }
    });
    
    // Find the variant using the selected option values
    var variant = findVariantByOptions(productJson, selectedOptions);
    
    // Fallback 1: try to get from productSelect if variant not found
    if (!variant) {
      var productSelect = form.querySelector('#productSelect');
      if (productSelect) {
        var selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption && selectedOption.value) {
          var variantId = selectedOption.value;
          
          for (var i = 0; i < productJson.variants.length; i++) {
            if (productJson.variants[i].id.toString() === variantId.toString()) {
              variant = productJson.variants[i];
              break;
            }
          }
        }
      }
    }
    
    // Fallback 2: try to get from URL parameter ?variant= if variant still not found
    if (!variant) {
      var urlParams = new URLSearchParams(window.location.search);
      var variantIdFromUrl = urlParams.get('variant');
      if (variantIdFromUrl) {
        for (var j = 0; j < productJson.variants.length; j++) {
          if (productJson.variants[j].id.toString() === variantIdFromUrl.toString()) {
            variant = productJson.variants[j];
            break;
          }
        }
      }
    }
    
    // Find the product section
    var productSection = form.closest('.page-section.product, .mount-product-page');
    if (!productSection) {
      return;
    }
    
    // Get inventory quantity from variant
    var inventoryQuantity = 0;
    
    // Get data from productSelect option if available
    var productSelect = form.querySelector('#productSelect');
    var productSelectOption = null;
    if (productSelect && variant) {
      productSelectOption = productSelect.querySelector('option[value="' + variant.id + '"]');
      if (productSelectOption) {
        var quantity = productSelectOption.getAttribute('data-quantity');
        if (quantity !== null && quantity !== undefined) {
          inventoryQuantity = parseInt(quantity);
        }
      }
    }
    
    // Fallback to variant.inventory_quantity if not found in productSelect
    if (inventoryQuantity === 0 && variant && variant.inventory_quantity !== undefined) {
      inventoryQuantity = parseInt(variant.inventory_quantity);
    }
    
    // Update the data-product-inventory-value element
    var inventoryValueElement = productSection.querySelector('[data-product-inventory-value]');
    if (inventoryValueElement) {
      inventoryValueElement.textContent = inventoryQuantity;
    }
  }
  
  // Listen for changes to productSelect and variant selects using event delegation
  // This handles dynamically added elements and avoids duplicate listeners
  document.addEventListener('change', function(e) {
    if (e.target.id === 'productSelect' || e.target.classList.contains('product__variant')) {
      if (e.target.id === 'productSelect') {
        updateVariantInventoryQuantity();
        // Update data-product-inventory-value
        var form = e.target.closest('.product__form');
        if (form) {
          setTimeout(function() {
            updateProductInventoryValue(form);
          }, 100);
        }
      } else {
        // Wait a bit for the productSelect to update when variant select changes
        setTimeout(function() {
          updateVariantInventoryQuantity();
          // Also update the selected text
          updateSelectedText(e.target);
          // Update data-product-inventory-value - wait longer for productSelect to update
          var form = e.target.closest('.product__form');
          if (form) {
            setTimeout(function() {
              updateProductInventoryValue(form);
            }, 150);
          }
        }, 100);
      }
    }
  });
  
  // Also listen for mutations on the variant selects (for styled select libraries)
  var mutationObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' || mutation.type === 'childList') {
        var target = mutation.target;
        if (target.classList && target.classList.contains('product__variant-holder')) {
          setTimeout(updateVariantInventoryQuantity, 50);
        }
        // If a .regular-select-inner was just added, update the selected text
        if (mutation.addedNodes) {
          Array.from(mutation.addedNodes).forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && node.classList.contains('regular-select-inner')) {
                var select = node.closest('.product__variant-holder');
                if (select) {
                  select = select.querySelector('.product__variant');
                  if (select) {
                    setTimeout(function() {
                      updateSelectedText(select);
                    }, 50);
                  }
                }
              }
            }
          });
        }
      }
    });
  });
  
  // Observe variant holders for changes
  function observeVariantHolders() {
    var variantHolders = document.querySelectorAll('.product__variant-holder');
    variantHolders.forEach(function(holder) {
      mutationObserver.observe(holder, {
        childList: true,
        subtree: true,
        attributes: true
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // initCartLinkButton(); // COMMENTED OUT: Client no longer needs view cart button
      initAddToCartOpenDrawer();
      initVariantInventoryQuantity();
      setTimeout(observeVariantHolders, 200);
    });
  } else {
    // DOM is already ready
    // initCartLinkButton(); // COMMENTED OUT: Client no longer needs view cart button
    initAddToCartOpenDrawer();
    initVariantInventoryQuantity();
    setTimeout(observeVariantHolders, 200);
  }
  
  // Re-initialize when Shopify section loads (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      // initCartLinkButton(); // COMMENTED OUT: Client no longer needs view cart button
      initAddToCartOpenDrawer();
      initVariantInventoryQuantity();
      observeVariantHolders();
    }, 200);
  });
})();
